import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import { AuthenticateService } from 'src/app/shared/services/authenticate.service';
import { Groupsservice } from 'src/app/shared/services/groups.service';
import { RepoService } from '../../shared/services/repo.service'
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
@Component({
  selector: 'app-add-sub-group',
  templateUrl: './add-sub-group.component.html',
  styleUrls: ['./add-sub-group.component.sass']
})
export class AddSubGroupComponent implements OnInit {


  subGroupForm: FormGroup;
  subGroupObj: any = {};
  name: string;
  description: string;
  globalImgUrl: string;
  urls = [];
  imageNameList = [];
  categoryImage: any;
  uploadFileList: any[] = [];
  imageUploadService: string;
  cropUuid: string = '';
  componentData: any;
  selectedCrop: any;
  cropVarietiesArray: any = [];
  loading: boolean;
  btnLoading: boolean = false;
  groupsArray: any[] = [];
  selectSubGroupList: any[] = [];
  selectSubGroupList1: any[] = [];
  selectSubGroupList2: any[] = [];
  subGroupsArray: any[] = [];
  showList: boolean = true;
  type: string;
  temp_groupName: any;
  firstselectedGroup: any;
  editIndex: any;
  // groupId: string;
  temp_id: string;
  temp_groupId: any;
  selectedRecord: any;
  groupId: any;
  groupName: any;
  available: boolean;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private groupsservice: Groupsservice,
    private fileUploadService: FileUploadService) { }

  ngOnInit() {
    this.subGroupForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      groupName: ['', Validators.required],
      available: ['', Validators.required]
    });
    this.getAllSubGroups();
    this.getAllGroups();
  }
  ngDoCheck() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
  }
  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }
  getAllGroups() {
    this.groupsArray = [];
    this.selectSubGroupList1 = [];
    // this.loading = true;
    this.groupsservice.getAllECGroups({}).then((data: any) => {
      if (data.length > 0) {
        this.groupsArray = data;
        console.log("@@ Groups array:", this.groupsArray);
        this.groupsArray.forEach(element => {
          let obj = {
            s_uuid: element.groupId,
            s_name: element.name,
          }
          this.selectSubGroupList1.push(obj);
        });
        this.selectSubGroupArray();
        // this.loading = false;
      } else {
        // this.loading = false;
      }
    });
  }
  getAllSubGroups() {
    this.loading = true;
    this.subGroupsArray = [];
    this.selectSubGroupList2 = [];
    this.groupsservice.getAllECSubGroups({}).then((data: any) => {
      if (data.length > 0) {
        this.subGroupsArray = data;
        this.subGroupsArray.forEach(element => {
          let obj = {
            s_uuid: element.uuid,
            s_name: element.name
          }
          this.selectSubGroupList2.push(obj);
        });
        this.selectSubGroupArray();
        this.loading = false;
        console.log("@@ sub Groups array:", this.subGroupsArray);
        console.log("selectSubGroupList2", this.selectSubGroupList2);
      } else {
        this.loading = false;
      }
    });
  }
  selectSubGroupArray() {
    this.selectSubGroupList = [];
    if (this.selectSubGroupList1.length > 0) {
      this.selectSubGroupList1.forEach(element => {
        this.selectSubGroupList.push(element);
      });
    }
    if (this.selectSubGroupList2.length > 0) {
      this.selectSubGroupList2.forEach(element => {
        this.selectSubGroupList.push(element);
      });
    }
    console.log("selectSubGroupList", this.selectSubGroupList);
    this.selectSubGroupList = this.selectSubGroupList.sort((a, b) => a.s_name.localeCompare(b.s_name))
  }
  getSelectedGroup(e) {
    this.temp_groupName = '';
    this.selectedRecord = this.selectSubGroupList.find(item => item.s_uuid == e);
    this.subGroupObj.groupName = this.selectedRecord.s_name;
  }
  addSubGroup() {
    this.btnLoading = false;
    this.subGroupForm.reset();
    this.showList = false;
    this.imageNameList = []; // TO SAVE IMAGE URLS
    this.urls = [];   // TO SAVE IMAGE URLS
    this.subGroupObj = {};
    this.type = 'save';
  }
  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split('/')[0] == 'image') {
          var reader = new FileReader()
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          }
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set('file', event.target.files[i], this.imageUploadService);
          formData.append('name', this.imageUploadService)
          this.uploadFileList.push(formData)
        }
      }
    }
  }
  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList, event);
  }
  onChangeState(event) {
    this.subGroupObj.available = event.currentValue;
  }
  saveData() {
    this.loading = true;
    this.btnLoading = true;
    let obj = {
      uuid: UUID.UUID(),
      groupId: this.selectedRecord.s_uuid,
      name: this.subGroupObj.name,
      image: this.imageNameList,
      description: this.subGroupObj.description,
      groupName: this.selectedRecord.s_name,
      // available : true
      available: this.subGroupObj.available,
    }
    console.log("obj::", obj)
    this.groupsservice.saveECSubGroups(obj).then((data: any) => {
      console.log("data::", data)
      if (this.imageUploadService) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (data) {
        Swal({ title: "Saved successfully" })
        this.getAllSubGroups();
        this.subGroupForm.reset();
        this.imageNameList = [];
        this.urls = [];
        this.uploadFileList = [];
        this.showList = true;
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
        this.showList = true;
      }
    });
  }
  uploadFileToActivity() {
    for (var i = 0; i < this.uploadFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.uploadFileList[i], this.imageUploadService);
    }
  }
  editCancel() {
    this.showList = true;
    this.getAllSubGroups();
    this.getAllGroups();
  }
  cancel() {
    // this.subGroupForm.reset();
    this.showList = true;
    this.imageNameList = [];
    this.urls = [];
    // this.getAllGroups();
    this.getAllSubGroups();
  }
  editData(index) {
    this.temp_id = '';
    this.showList = false;
    this.imageNameList = [];
    this.urls = [];
    this.editIndex = index;
    console.log("group edited", this.subGroupsArray[index]);
    this.subGroupObj = this.subGroupsArray[index];
    this.groupId = this.subGroupsArray[index].groupId;
    this.groupName = this.subGroupsArray[index].groupName;
    this.temp_id = this.subGroupObj.uuid; //TO UPDATE SAME UUID VALUES   
    this.imageNameList = this.subGroupsArray[index].image;
    for (var i = 0; i < this.subGroupsArray[index].image.length; i++) {
      this.urls.push(this.globalImgUrl + this.subGroupsArray[index].image[i]);
      this.uploadFileList.push(this.globalImgUrl + this.subGroupsArray[index].image[i]);
    }
    this.type = 'update';
  }

  updateData() {
    this.loading = true;
    this.btnLoading = true;
    this.subGroupObj.image = this.subGroupObj.image.concat(this.imageNameList.filter((item) => {
      return this.subGroupObj.image.indexOf(item) < 0;
    }));
    let obj = {
      uuid: this.temp_id,
      groupId: this.selectedRecord ? this.selectedRecord.s_uuid : this.groupId,
      name: this.subGroupObj.name,
      image: this.subGroupObj.image,
      description: this.subGroupObj.description,
      available: this.subGroupObj.available,
      groupName: this.selectedRecord ? this.selectedRecord.s_name : this.groupName
    }
    console.log("@Update obj=", obj)
    this.groupsservice.updateECSubGroups(obj, this.temp_id).then((data: any) => {
      if (this.imageUploadService) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (data) {
        Swal({ title: "Updated successfully" })
        this.subGroupForm.reset();
        this.imageNameList = [];
        this.urls = [];
        this.uploadFileList = [];
        this.showList = true;
        this.getAllSubGroups();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
        this.showList = true;
      }
    })
  }



}
